'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import QuickShipFilter from 'components/essentials/ConsumerFilters/components/QuickShipFilter';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';
import WidthRangeFilter from 'components/consumer/consumer-search/advanced-search-next/components/WidthRangeFilter';
import ClearAllFiltersButtonComponent from 'components/consumer/consumer-search/advanced-search-next/components/ClearAllFiltersButton';
import CategorySearchBox from './CategorySearchBox';
import CategoryFacetFilter from './CategoryFacetFilter';
import { getSkipFilterIds } from '../categoryPageSlugUtils';
import { PAGE_TYPE, getCategoryPageTypeConfig } from '../categoryPageTypes';
const CategoryAlgoliaSidebar = t0 => {
  const $ = _c(27);
  const {
    pageName,
    pageType: t1,
    filters,
    selectedFacets,
    onToggleFacet
  } = t0;
  const pageType = t1 === undefined ? PAGE_TYPE.CATEGORY : t1;
  let t2;
  if ($[0] !== pageType) {
    t2 = getCategoryPageTypeConfig(pageType);
    $[0] = pageType;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    showSearchBox,
    showReadyToShipToggle,
    showWidthFilter
  } = t2;
  const {
    isReadyToShipActive,
    handleToggleReadyToShip
  } = useAdvancedSearchContext();
  let t3;
  if ($[2] !== filters || $[3] !== pageType) {
    const skipFilterIds = getSkipFilterIds(pageType);
    t3 = (filters || []).filter(f => !skipFilterIds.has(f.id) && f.options?.length > 0);
    $[2] = filters;
    $[3] = pageType;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const dynamicFilters = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ClearAllFiltersButtonComponent />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== pageName || $[7] !== showSearchBox) {
    t5 = showSearchBox && <CategorySearchBox pageName={pageName} />;
    $[6] = pageName;
    $[7] = showSearchBox;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleToggleReadyToShip || $[10] !== isReadyToShipActive || $[11] !== showReadyToShipToggle) {
    t6 = showReadyToShipToggle && <QuickShipFilter isChecked={isReadyToShipActive} onChange={handleToggleReadyToShip} minHeight={false} withLocation={true} />;
    $[9] = handleToggleReadyToShip;
    $[10] = isReadyToShipActive;
    $[11] = showReadyToShipToggle;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== showWidthFilter) {
    t7 = showWidthFilter && <WidthRangeFilter showTitle={true} />;
    $[13] = showWidthFilter;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== dynamicFilters || $[16] !== onToggleFacet || $[17] !== selectedFacets) {
    let t9;
    if ($[19] !== onToggleFacet || $[20] !== selectedFacets) {
      t9 = filter => <CategoryFacetFilter key={filter.id} attribute={filter.id} label={filter.label} options={filter.options} selectedValues={selectedFacets?.[filter.id] || new Set()} onToggle={onToggleFacet} />;
      $[19] = onToggleFacet;
      $[20] = selectedFacets;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    t8 = dynamicFilters.map(t9);
    $[15] = dynamicFilters;
    $[16] = onToggleFacet;
    $[17] = selectedFacets;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t9 = <div className="pb-4">{t4}<div className="flex flex-col gap-5">{t5}{t6}{t7}{t8}</div></div>;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
CategoryAlgoliaSidebar.propTypes = {
  pageName: PropTypes.string,
  pageType: PropTypes.oneOf(Object.values(PAGE_TYPE)),
  filters: PropTypes.array,
  selectedFacets: PropTypes.object,
  onToggleFacet: PropTypes.func
};
export default CategoryAlgoliaSidebar;